export const thead = [
  { name: "Nº Formulario", order: null },
  { name: "Proveedor", order: null },
  { name: "Fecha autorización", order: null },
  { name: "Factura comercial", order: null },
  { name: "Código", order: null },

  { name: "DTA", order: null }
];
